import React, { Component } from 'react';
import Summary from './Summary';
import StatementsContainer from './StatementsContainer';
import ScrollLock from 'react-scrolllock';
import EncourageScroll from '../EncourageScroll';
import './payments.css';

class PaymentsContainer extends Component {
  render() {
    const { payments, latestStatement, selectPayment, currentUser, highestPaycheck, togglePayingBalance } = this.props;
    return (
      <ScrollLock>
        <EncourageScroll className="payments__statements--scroll">
          <div className="payments__statements">
            <Summary
              currentUser={currentUser}
              latestStatement={latestStatement}
              isLatestStatement
              highestPaycheck={highestPaycheck}
              togglePayingBalance={togglePayingBalance}
            />
            <StatementsContainer selectPayment={selectPayment} payments={payments} />
          </div>
        </EncourageScroll>
      </ScrollLock>
    );
  }
}

export default PaymentsContainer;



// WEBPACK FOOTER //
// ./src/components/NewPayments/PaymentsContainer.js